(() => {
  const clean = value => String(value || '').replace(/[\u0000-\u001f\u007f]/g, ' ').trim().slice(0,100);
  function parse(search) {
    const params = new URLSearchParams(search), type = params.get('inquiry_type');
    if (!['corporate','catalog'].includes(type)) return null;
    return {type, query:type === 'catalog' ? clean(params.get('inquiry_query')) : ''};
  }
  if (typeof module !== 'undefined' && module.exports) {module.exports = {parse};return;}
  function fill() {
    document.querySelectorAll('[data-ace-consultation-entry]').forEach(box => {
      if (box.dataset.ready === 'true' || box.dataset.posted === 'true') return;
      const typeField = box.querySelector('[data-entry-type]'), queryField = box.querySelector('[data-entry-query]');
      const saved = typeField.value;
      const entry = ['corporate','catalog'].includes(saved) ? {type:saved,query:clean(queryField.value)} : parse(location.search);
      if (!entry) return;
      typeField.value = entry.type;
      if (!queryField.value) queryField.value = entry.query;
      box.querySelector('[data-entry-query-row]').hidden = entry.type !== 'catalog' || !queryField.value;
      box.querySelector('[data-entry-corporate]').hidden = entry.type !== 'corporate';
      box.querySelector('[data-entry-catalog]').hidden = entry.type !== 'catalog';
      box.hidden = false; box.dataset.ready = 'true';
      const form = box.closest('form');
      if (form) {
        if (entry.type === 'corporate') {
          const source = form.querySelector('[data-ace-inquiry-context]');
          if (source) source.after(box);
          else form.prepend(box);
        }
        const action = new URL(form.action,location.origin);
        if (action.origin === location.origin) {
          action.searchParams.set('inquiry_type',entry.type);
          if (entry.type === 'catalog' && queryField.value) action.searchParams.set('inquiry_query',clean(queryField.value));
          else action.searchParams.delete('inquiry_query');
          form.action = action.href;
        }
      }
    });
  }
  if(document.readyState === 'loading')document.addEventListener('DOMContentLoaded',fill,{once:true});else fill();
  document.addEventListener('shopify:section:load',fill);
})();

